import { Link } from "react-router-dom";
import { pagePath } from "@/lib/translations";
import { Star } from "lucide-react";

export const RATING_TXT = {
  de: { of: "von 5", from: (n) => `aus ${n} Bewertungen`, none: "Noch keine Bewertungen", link: "Alle Gästestimmen lesen →" },
  en: { of: "out of 5", from: (n) => `from ${n} reviews`, none: "No reviews yet", link: "Read all guest reviews →" },
  es: { of: "de 5", from: (n) => `de ${n} opiniones`, none: "Aún sin opiniones", link: "Leer todas las opiniones →" },
  nl: { of: "van 5", from: (n) => `uit ${n} beoordelingen`, none: "Nog geen beoordelingen", link: "Alle gastenreacties lezen →" },
  pl: { of: "na 5", from: (n) => `z ${n} opinii`, none: "Brak opinii", link: "Czytaj wszystkie opinie →" },
  fr: { of: "sur 5", from: (n) => `sur ${n} avis`, none: "Pas encore d'avis", link: "Lire tous les avis →" },
  it: { of: "su 5", from: (n) => `da ${n} recensioni`, none: "Ancora nessuna recensione", link: "Leggi tutte le recensioni →" },
};

export const Stars = ({ value, className = "w-5 h-5" }) => (
  <span className="inline-flex gap-0.5" aria-hidden="true">
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`${className} ${i <= Math.round(value) ? "fill-gold text-gold" : "text-stone-300"}`} />)}
  </span>
);

/** Startseiten-Kachel: Gesamtnote + Sterne + Anzahl, verlinkt auf /bewertungen (schema.org AggregateRating liefert Home.jsx im Organisations-Schema). */
export const RatingTile = ({ lang = "de", title, text, summary }) => {
  const s = summary;
  const x = RATING_TXT[lang] || RATING_TXT.de;
  const fmt = (n) => (lang === "en") ? String(n) : String(n).replace(".", ",");
  return (
    <div className="border-l-2 border-brand pl-6" data-testid="value-prop-rating">
      <Star className="w-8 h-8 text-brand mb-4" />
      <h2 className="font-serif text-2xl text-stone-900 mb-2">{title}</h2>
      {s && s.count > 0 ? (
        <>
          <Link to={pagePath("bewertungen")} className="block group" data-testid="rating-tile-link" title={x.link}>
            <div className="flex items-end gap-2"><span className="text-2xl font-serif text-stone-900" data-testid="rating-tile-avg">{fmt(s.average)}</span><span className="text-xs text-stone-500 mb-1">{x.of}</span></div>
            <div className="flex items-center gap-2 mt-1"><Stars value={s.average} className="w-4 h-4" /><span className="text-xs text-stone-500 group-hover:text-brand" data-testid="rating-tile-count">{x.from(s.count)}</span></div>
          </Link>
          <p className="text-sm text-stone-600 leading-relaxed mt-2">{text}</p>
        </>
      ) : <p className="text-sm text-stone-600 leading-relaxed">{s ? x.none : "…"}</p>}
    </div>
  );
};
